import {
  type AxiosRequestConfig,
  type DefaultQueryError,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';

interface OTPLoginRequestBody {
  code: string;
  phone_number: string;
}

export interface OTPLoginResponse {
  customer_id: string;
  access_token: string;
}

export const OTPLoginFn = async (
  body: OTPLoginRequestBody,
  config: AxiosRequestConfig = {}
): Promise<OTPLoginResponse> => {
  const response = await publicHttpClient.post<OTPLoginResponse>(
    apiRoutes.ahafood.store.login_otp,
    body,
    {
      ...config,
    }
  );

  return response?.data;
};

export const useLoginOTP = (
  opts?: UseMutationOptions<
    OTPLoginResponse,
    DefaultQueryError,
    OTPLoginRequestBody
  >
) => {
  return useMutation<OTPLoginResponse, DefaultQueryError, OTPLoginRequestBody>({
    mutationFn: OTPLoginFn,
    ...opts,
  });
};
